export enum FileSizeLimits {
  Image = 7,
  File = 25,
  Video = 500,
  FormOptionsFile = 1,
}

export const UppyImageAllowedFileTypes = [
  '.jpg',
  '.jpeg',
  '.png',
  '.webp',
  '.jfif',
];

export const UppyVideoAllowedFileTypes = [
  '.mp4',
  '.m4v',
  '.mov',
  '.webm',
  '.avi',
  '.mkv',
];

export const UppySsoIconAllowedFileTypes = ['.jpg', '.jpeg', '.png', '.webp'];

export const UppyDocumentationAllowedFileTypes = [
  ...UppyImageAllowedFileTypes,
  '.pdf',
];

export const UppyDataImportAllowedFileTypes = ['.xlsx', '.csv'];

export const UppyDocumentationImportAllowedFileTypes = [
  ...UppyImageAllowedFileTypes,
  ...UppyVideoAllowedFileTypes,
  '.pdf',
];

export const UppyZipArchiveAllowedFileTypes = ['.zip'];

function getFileSizeLimit(size: FileSizeLimits) {
  return size * 1024 * 1024;
}

export const uppyCompressorOptions = {
  maxWidth: 1920,
  quality: 0.8, // targets ~500KB for typical photos
  convertSize: 524288, // 512KB threshold — compress if larger
};

export const fileSizeLimits = {
  '.jpg': getFileSizeLimit(FileSizeLimits.Image),
  '.jpeg': getFileSizeLimit(FileSizeLimits.Image),
  '.png': getFileSizeLimit(FileSizeLimits.Image),
  '.webp': getFileSizeLimit(FileSizeLimits.Image),
  '.jfif': getFileSizeLimit(FileSizeLimits.Image),
  '.pdf': getFileSizeLimit(FileSizeLimits.File),
  '.xlsx': getFileSizeLimit(FileSizeLimits.File),
  '.csv': getFileSizeLimit(FileSizeLimits.File),
  '.mp4': getFileSizeLimit(FileSizeLimits.Video),
  '.m4v': getFileSizeLimit(FileSizeLimits.Video),
  '.mov': getFileSizeLimit(FileSizeLimits.Video),
  '.webm': getFileSizeLimit(FileSizeLimits.Video),
  '.avi': getFileSizeLimit(FileSizeLimits.Video),
  '.mkv': getFileSizeLimit(FileSizeLimits.Video),
};

export const imageSizeLimit = getFileSizeLimit(FileSizeLimits.File);

export const fileSizeLimit = getFileSizeLimit(FileSizeLimits.File);

export const videoSizeLimit = getFileSizeLimit(FileSizeLimits.Video);

export const formOptionsFileSizeLimit = getFileSizeLimit(
  FileSizeLimits.FormOptionsFile,
);

export const getMaxFileSize = (fileType: string) => fileSizeLimits[fileType];
